import type { KpiPeriod } from "@/features/kpi/periodFilter";
import { KPI_PERIODS, useKpiPeriod } from "@/hooks/useKpiPeriod";
import { t } from "@/i18n";

function parse(value: string): KpiPeriod {
  if (value === "today" || value === "all") return value;
  const n = Number(value);
  return n === 7 || n === 90 ? n : 30;
}

/**
 * Ust bar kuyruk donem secici — eski `#periodSel` (Bugün / Son 7 Gün /
 * Son 30 Gün / Tüm Zamanlar). Kargolanmamis, kargo yolda, destek, iade,
 * odeme bekleyen gibi tarihli kuyruk kartlarini daraltir; gidisat donem
 * sekmeleri (7/30/90) ayridir.
 */
export function KpiPeriodSelect() {
  const { kpiPeriod, setKpiPeriod } = useKpiPeriod();
  return (
    <label className="inline-flex items-center gap-2 text-sm text-muted">
      <span className="hidden sm:inline">{t("kpi.period.label")}</span>
      <select
        aria-label={t("kpi.period.label")}
        data-testid="kpi-period-select"
        value={String(kpiPeriod)}
        onChange={(e) => setKpiPeriod(parse(e.target.value))}
        className="min-h-[44px] rounded-md border border-line bg-card px-2 text-sm font-medium text-ink"
      >
        {KPI_PERIODS.map((p) => (
          <option key={String(p)} value={String(p)}>
            {t(`kpi.period.${p}`)}
          </option>
        ))}
      </select>
    </label>
  );
}
